import { ChevronRight, GraduationCap, PieChart, Shapes } from 'lucide-react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  data: {
    header: string;
    title: string;
  };
}

const StudentLearnInteractiveCard: FC<Props> = ({ data }) => {
  const navigate = useNavigate();
  return (
    <button
      className="nc_student-learn-interactive-card"
      onClick={() => {
        const state = { from: '/how-students-learn' };
        data.title === 'Area & Perimeter'
          ? navigate('/guided-tour/perimeter-and-area-of-rectangles', { state })
          : navigate('/guided-tour/proportion-graphs', { state });
      }}
    >
      <span className="nc_student-learn-interactive-card-icon">
        {data.title === 'Area & Perimeter' ? <Shapes size={24} color="white" /> : <PieChart size={24} color="white" />}
      </span>
      <div className="tw-flex tw-flex-col tw-gap-y-2">
        <span className="tw-border-2 tw-border-solid tw-border-sky-100 tw-bg-sky-50 tw-text-sky-700 tw-text-xs tw-font-bold tw-rounded-xl tw-px-2 tw-py-1 tw-flex tw-flex-row tw-gap-x-1 tw-items-center tw-font-atkinson">
          <GraduationCap size={12} className="tw-text-sky-700" />
          {data.header}
        </span>
        <h1 className="tw-text-base tw-font-bold tw-font-atkinson">{data.title}</h1>
      </div>
      <ChevronRight size={24} className="tw-text-neutral-950 tw-ml-auto" />
    </button>
  );
};

export default StudentLearnInteractiveCard;
